import fetch from "../../utils/fetch";

export function latestRecord(params) {
    
  return fetch({
    url: "/api/alipay/parking-assistant/latest-record",
    method: "get",
    params: params
  });
}
export function submitOrderFeedback(params) {
  return fetch({
    url: "/api/alipay/parking-assistant/feedback",
    method: "post",
    data: params
  });
}

